import React from 'react';
import { Typography, Box } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HandsOnMobile from '../assets/img/handsonmobile.jpg';
import useStyles from '../styles/styles';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

const DownloadApp = () => {
  const classes = useStyles();
  const settings = useSelector(state => state.settingsdata.settings);
  const { t } = useTranslation();

  return (
    <Box className={classes.aboutUsContainer} id="download">
      <div className={classes.aboutLayout}>
        <div className={classes.aboutImageCol}>
          <div className={classes.aboutImageWrap}>
            <img src={HandsOnMobile} alt="Conecta2" className={classes.aboutImage} />
            <div className={classes.aboutImageOverlay}>
              <Typography className={classes.aboutImageCaption}>
                TU DESTINO EN BUENAS MANOS
              </Typography>
              <div className={classes.aboutImageCaptionLine} />
            </div>
          </div>
        </div>

        <div className={classes.aboutContentCol}>
          <Typography className={classes.aboutEyebrow}>CONOCE MÁS</Typography>
          <Typography component="h2" className={classes.aboutTitle}>
            Estamos <span>Conecta2</span>
          </Typography>
          <Typography className={classes.aboutBody}>
            {t('app_store_deception1')}
          </Typography>

          <div className={classes.aboutStoreRow}>
            {settings && settings.AppleStoreLink ? (
              <a href={settings.AppleStoreLink} className={classes.aboutStoreLink} target="_blank" rel="noreferrer">
                <img src={require("../assets/img/appstore.png")} alt="App Store" className={classes.aboutStoreBadge} />
              </a>
            ) : null}
            {settings && settings.PlayStoreLink ? (
              <a href={settings.PlayStoreLink} className={classes.aboutStoreLink} target="_blank" rel="noreferrer">
                <img src={require("../assets/img/playstore.png")} alt="Google Play" className={classes.aboutStoreBadge} />
              </a>
            ) : null}
          </div>

          <div className={classes.aboutDecor} aria-hidden="true">
            <LocationOnIcon className={classes.aboutPin} />
            <svg className={classes.aboutRoute} viewBox="0 0 80 220" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M48 8 C 18 48, 62 78, 28 118 C 2 148, 52 168, 36 210"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div className={classes.aboutFooterTag}>
            <div className={classes.aboutFooterLine} />
            <span>EN TODO COLOMBIA</span>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default DownloadApp;
